import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  set<T>(chave: string, valor: T): boolean {
    try {
      if (typeof valor === 'string') {
        localStorage.setItem(chave, valor);
      } else if (typeof valor === 'number' || typeof valor === 'boolean') {
        localStorage.setItem(chave, `${valor}`);
      } else {
        localStorage.setItem(chave, JSON.stringify(valor));
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  get(chave: string): string | null {
    try {
      if (!localStorage.getItem(chave)) {
        return null;
      }
      return localStorage.getItem(chave);
    } catch (e) {
      return null;
    }
  }

  remover(chave: string): boolean {
    if (this.get(chave)) {
      localStorage.removeItem(chave);
      return true;
    }
    return false;
  }

  clear() {
    localStorage.clear();
  }
}
